export default function extractScaleCode(salaryScaleName) {
  if (!salaryScaleName) return ''

  const words = salaryScaleName.split(' ')
  let code = ''

  words.forEach((word, index) => {
    // If the word contains a number, we take that as the scale code
    if (parseInt(word)) {
      code = word
    } else if (!code && index === words.length - 1) {
      // If no number was present in the name, we take the last word as the scale code
      code = word
    }
  })

  return code
}
